// extracted by mini-css-extract-plugin
module.exports = {"endIcon":"styles_endIcon__1gCrc","option":"styles_option__29CAP","startIcon":"styles_startIcon__1lK94"};